import React from 'react';
import PropTypes from 'prop-types';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import Colors from '../colors';
const getFontFamily = Platform.select({
  web: fontFamily => `'${fontFamily}, Helvetica, Arial, system-ui, sans-serif'`,
  default: fontFamily => `${fontFamily}`
});
const StyledText = styled.Text`
  font-family: ${_ref => {
  let {
    fontFamily
  } = _ref;
  return getFontFamily(fontFamily);
}};
  font-size: ${props => props.size}px;
  color: ${props => props.color};
  text-align: ${props => props.align};
  text-decoration-line: ${props => props.textDecorationLine};
  line-height: ${props => props.lineHeight}px;
`;
export default function Text(props) {
  return /*#__PURE__*/React.createElement(StyledText, props, props.children);
}
Text.defaultProps = {
  fontFamily: 'LarsseitRegular',
  size: 16,
  color: Colors.gray600,
  align: 'left',
  textDecorationLine: 'none',
  lineHeight: 20,
  children: '',
  onPress: undefined,
  href: undefined
};
Text.propTypes = {
  fontFamily: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  textDecorationLine: PropTypes.oneOf(['none', 'underline', 'line-through', 'underline line-through']),
  lineHeight: PropTypes.number,
  children: PropTypes.node,
  onPress: PropTypes.func,
  href: PropTypes.string
};
//# sourceMappingURL=text.js.map